






























































































import { Notify } from 'quasar';
import { defineComponent, PropType, ref } from '@vue/composition-api';
import { buildRule } from '@ligo/shared/mvc';
import { ResetTexts } from '../../models';
import { ApiService } from '@ligo/shared/utils';

export default defineComponent({
  name: 'ResetPassword',
  props: {
    access_token: {
      type: String
    },
    client: {
      type: String
    },
    expiry: {
      type: String
    },
    uid: {
      type: String
    },
    base: {
      type: String,
      default: ''
    },
    texts: {
      type: Object as PropType<ResetTexts>,
      default: () => ({
        passLabel: 'auth.change_password.new_password',
        passPlaceholder: 'auth.change_password.new_password_placeholder',
        confirmLabel: 'auth.change_password.confirm_password',
        confirmPlaceholder: 'auth.change_password.confirm_password_placeholder'
      })
    }
  },
  setup(props, { root }) {
    const formRef = ref();
    const loading = ref(false);

    function onChangePassword() {
      formRef.value.validate().then((valid) => {
        if (valid) {
          loading.value = true;
          ApiService.setHeaders({
            access_token: props.access_token,
            expiry: props.expiry,
            client: props.client,
            uid: props.uid
          } as any);
          ApiService.put(`${props.base}/password`, {
            password: password.value,
            password_confirmation: confirm.value
          })
            .then((response) => {
              loading.value = false;
              Notify.create({
                type: 'positive',
                color: 'primary',
                position: 'top',
                message: response.data['message']
              });
              ApiService.removeHeader();
              root.$router.push({ name: 'Login' });
            })
            .catch((error) => {
              loading.value = false;
              console.log({ error });
              ApiService.removeHeader();
              Notify.create({
                type: 'negative',
                color: 'red',
                position: 'top',
                message:
                  error?.response?.data?.errors[0] ||
                  root.$t('auth.change_password.error')
              });
            });
        }
      });
    }

    const password = ref('');
    const passwordVisibility = ref(false);
    const confirm = ref('');
    const confirmVisibility = ref(false);

    const passwordRules = [
      buildRule('required', 'validations.required_generic'),
      buildRule('password', 'validations.password_length')
    ];
    const confirmRules = [
      buildRule('required', 'validations.required_generic'),
      (v) => v === password.value || root.$t('auth.reset.confirm_error')
    ];

    return {
      onChangePassword,
      formRef,
      confirm,
      confirmVisibility,
      password,
      passwordVisibility,
      confirmRules,
      passwordRules,
      loading
    };
  }
});
